  import { goBack } from "assets/icons";
  import styled from "@emotion/styled";
  import { Card, Col, Form, Row, Tabs, Typography, message } from "antd";
  import { useNavigate } from "react-router-dom";
  import MainCreateAgent from "./AgentComponents/MainCreateAgent";
  import MainCreateAgentAddress from "./AddressComponents/MainCreateAgentAddress";
  import FooterCreateAgent from "./FooterCreateAgent";
  import { useGetMasterProvince } from "hooks/useMasterData";
  import { useState } from "react";
  import { AddressData } from "./AddressComponents/interface/address.interface";
  import { useCreateAgent } from "hooks/useFactory";
import { QueryClient } from "@tanstack/react-query";

  
  const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };


  const CreateAgent = () => {
    const navigate = useNavigate();
    const queryClient = new QueryClient();

    const [dataAddress, setDataAddress] = useState<AddressData[] >([]);
    const { mutate: CreateAgent, isPending } = useCreateAgent();
    const [form] = Form.useForm();

    const { data: masterProviceData, isPending: proviceLoading } = useGetMasterProvince();
    
    const handleRemoveItem = (target: string) => {
      const updatedDataAddress = dataAddress.filter((item, index) => item.address_id !== target);
      setDataAddress(updatedDataAddress);
    };
    
    const items = [
      {
        label: `ข้อมูลทั่วไป`,
        key: "0",
        children: 
        <>
          <MainCreateAgent 
            form={form} 
            masterProviceData={masterProviceData}
          />
          {/* <Divider/>
          <MainCreateShippingOrder/> */}
          <Divider/>
          <MainCreateAgentAddress 
            form={form}
            dataAddress={dataAddress}
            handleRemoveItem={handleRemoveItem}
            setDataAddress={setDataAddress}
            masterProviceData={masterProviceData}
            searchOption={false}
            addTemporary={true}
          />
          <FooterCreateAgent loading={isPending} />
        </>,
      },
        {
          label: `รายการคำสั่งซื้อ`,
          key: "1",
          disabled: true,
        },  
    ];

    const onFinish = (values: any) => {
      let addressData: AddressData | null = null;

      if (values.address_text || values.province_id || values.district_id || values.sub_district_id || values.zip_code) {
        addressData = {
          line_1: values.address_text,
          province_id: values.province_id,
          district_id: values.district_id,
          sub_district_id: values.sub_district_id,
          post_code: values.zip_code,
          address_type: 'contact',
          transport_type: values.transport,
        }
      }

      const dataRaw: any = {
        first_name: values.firstname,
        last_name: values.lastname,
        mobile: values.telephone,
        email: values.email,
        address: addressData ? addressData : null,
        datasource: values.datasource,
        ship_address: dataAddress,
        facebook: values.facebook
      }

      CreateAgent(dataRaw, {
        onSuccess: async (res) => {
          if (res.status === "success") {
            message.success("สร้างตัวแทนสำเร็จ");
            await queryClient.refetchQueries({
              queryKey: ["load_contacts"],
              type: "active",
            });
            navigate(`/manage-agent/update-agent/${res.data}`)
          } else {
            message.error(`สร้างตัวแทนไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างตัวแทนไม่สำเร็จ: ${error.message}`);
        },
      });
    
    }
    return (
      <Form form={form} {...formItemLayout} onFinish={onFinish}>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/manage-agent");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>สร้างตัวแทน</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
            <Row className="rowgap-vbox" gutter={[24, 0]}>
              <Col sm={24} md={24}>
                <Tabs
                  defaultActiveKey={'0'}
                  style={{ height: "100%" }}
                  items={items}
                  key="key"
                />
              </Col>
            </Row>
            </WrapperAll>
          </Card>
        </Col>
      </Row>
    </Form>  
    );
  };

  export default CreateAgent;

  const ButtonWrapper = styled.div`
    max-width: 250px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  `;

  const Divider = styled.div`
    border-bottom: 0.5px solid #e8e8e8;
    margin: 10px 0px 10px 0px;
  `;

  const HeaderTabs = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    flex-direction: row;
    border-bottom: 1px solid #efefef;
  `;

  const IconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 30px;
    border-radius: 6px;
    background-color: #ffffff;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: #efefef;
    }
  `;

  const SpanIcon = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  `;

  const RightIconWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  `;

  const WrapperAll = styled.div`
    display: block;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    
  `;

  const DisabledOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  `;

  const DisabledMessage = styled.div`
    font-size: 24px;
    color: #333;
  `;
